/*Sidebar*/
/*eslint-disable */
import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/Beneficios.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Beneficios2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Etapas.svg'
import i_etapas2 from './../UI/icons/Sidebar/Etapas2.svg'
import i_vistas from './../UI/icons/Sidebar/Vistas.svg'
import i_vistas2 from './../UI/icons/Sidebar/Vistas2.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_BBQ from './../UI/icons/Amenities/BBQ.svg'
import i_Acceso_vehicular from './../UI/icons/Amenities/Entrada vehicular.svg'
import i_zona_Comercial from './../UI/icons/Amenities/ZonaComercial.svg'
import i_Parque from './../UI/icons/Amenities/Parque.svg'
import i_petPark from './../UI/icons/Amenities/PetPark.svg'
import i_Juegos_Infantiles from './../UI/icons/Amenities/Juegos infantiles.svg'
import i_Placa_Polideportiva from './../UI/icons/Amenities/CanchaMultiple.svg'
import i_Salon_Social from './../UI/icons/Amenities/SalonSocial.svg'
import i_Gym from './../UI/icons/Amenities/Gym.svg'
import i_Piscina from './../UI/icons/Amenities/piscina.svg'
import i_Gimnasio_Aire_libre from './../UI/icons/Amenities/GimnasioExterior.svg'
import i_Yoga from './../UI/icons/Amenities/Yoga.svg'

import i_BBQ2 from './../UI/icons/Amenities/BBQ2.svg'
import i_Acceso_vehicular2 from './../UI/icons/Amenities/Entrada vehicular2.svg'
import i_zona_Comercial2 from './../UI/icons/Amenities/ZonaComercial2.svg'
import i_Parque2 from './../UI/icons/Amenities/Parque2.svg'
import i_petPark2 from './../UI/icons/Amenities/PetPark2.svg'
import i_Juegos_Infantiles2 from './../UI/icons/Amenities/Juegos infantiles2.svg'
import i_Placa_Polideportiva2 from './../UI/icons/Amenities/CanchaMultiple2.svg'
import i_Salon_Social2 from './../UI/icons/Amenities/SalonSocial2.svg'
import i_Gym2 from './../UI/icons/Amenities/Gym2.svg'
import i_Piscina2 from './../UI/icons/Amenities/piscina2.svg'
import i_Gimnasio_Aire_libre2 from './../UI/icons/Amenities/GimnasioExterior2.svg'
import i_Yoga2 from './../UI/icons/Amenities/Yoga_White.svg'


/*POIS*/
import i_salud from './../UI/icons/POI/Salud2.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_resturantes from './../UI/icons/POI/Restaurantes.svg'


import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'
import i_resturantes2 from './../UI/icons/POI/Restaurantes2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'vistas': i_vistas,
    'vistas2': i_vistas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Acceso vehicular': i_Acceso_vehicular,
    'Acceso vehicular2': i_Acceso_vehicular2,
    'Locales comerciales': i_zona_Comercial,
    'Locales comerciales2': i_zona_Comercial2,
    'Parque': i_Parque,
    'Parque2': i_Parque2,
    'Zona de mascotas': i_petPark,
    'Zona de mascotas2': i_petPark2,
    'Parque infantil': i_Juegos_Infantiles,
    'Parque infantil2': i_Juegos_Infantiles2,  
    'Placa polideportiva': i_Placa_Polideportiva,
    'Placa polideportiva2': i_Placa_Polideportiva2,   
    'Salón social': i_Salon_Social,
    'Salón social2': i_Salon_Social2,
    'Gym': i_Gym,
    'Gym2': i_Gym2,
    'Piscina': i_Piscina,
    'Piscina2': i_Piscina2,
    'Gimnasio al aire libre': i_Gimnasio_Aire_libre,
    'Gimnasio al aire libre2': i_Gimnasio_Aire_libre2,
    'BBQ': i_BBQ,
    'BBQ2': i_BBQ2,
    'Yoga': i_Yoga,
    'Yoga2': i_Yoga2,


    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
    "Restaurantes": i_resturantes,
    "Restaurantes2": i_resturantes2,
}